<template>
  <div v-if="$apollo.loading">
    <spinner />
  </div>
  <main v-else class="content">
    <section class="main-section">
      <img
        src="/assets/hero-icons/successful-registration.svg"
        alt="successful email verification"
      >
      <div class="successful-text-container">
        <h1 class="successful-title">{{ $t('curatedInvitationResponse') }}</h1>
        <a :href="`${landingURL}`" target="_self">
          <main-button depressed text="nastavi" />
        </a>
      </div>
    </section>
  </main>
</template>

<script>
import { UPDATE_ANNUAL_TICKET_INVITE_ATTENDEE_STATUS } from '@/graphql/user.graphql'
import { landingURL } from '@/utils'

export default {
  props: {
    eventId: {
      type: String,
    },
    attendeeUUID: {
      type: String,
    },
    status: {
      type: String,
    },
  },
  data() {
    return {
      landingURL,
    }
  },
  async mounted() {
    const { errors } = await this.$apollo.mutate({
      mutation: UPDATE_ANNUAL_TICKET_INVITE_ATTENDEE_STATUS,
      variables: {
        eventId: this.eventId,
        attendeeUUID: this.attendeeUUID,
        status: this.status.toUpperCase(),
      },
    })

    if (errors) {
      console.log('aa')
    }
  },
}
</script>

<style scoped>
.content {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100%;
}

.main-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 42rem;
  justify-self: center;
}

.successful-text-container {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  align-items: center;
  margin-top: 4.5rem;
}

.successful-title {
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 800;
  font-size: 72px;
  line-height: 120%;
  text-align: center;
  letter-spacing: -0.03em;
  color: #333333;
}

@media screen and (max-width: 800px) {
  .successful-title {
    font-size: 24px !important;
  }
}
</style>
